import { FC, useState } from 'react';
import { useFm, useScreenType } from '@web3/base-hooks';
import {
  normalizeOutLink as normalizeLink,
  goBuy,
  goSwap,
  web3Navigate,
  replacePath,
  formatNumber,
} from '@web3/base-utils';
import { scTrack } from '@web3/base-tracking';
import { Button, Divider, EToastType, ToastContainer, toast } from '@bfe/moly';
import {
  EyeonIcon,
  EyeoffIcon,
  ArrowdownIcon,
  ArrowupIcon,
  CopyIcon,
} from '@bfe/moly-icons';
import copy from 'copy-to-clipboard';
import { Event, Page } from '@/config/track-config';
import {
  useShowBalance,
  useCurrentWallet,
  useConnectWalletModal,
  Web3CopyCloudWalletModal,
  useThirdWallet,
  Web3DepositModal,
} from '@web3fe/infra';

import 'swiper/css';
import 'swiper/css/pagination';

import styles from './index.module.scss';

export const Connected: FC = () => {
  const fm = useFm();
  const { isMobile } = useScreenType();

  // 是否展示余额
  const {
    visible: showBalance,
    show: setShowBalance,
    hide: hideBalance,
  } = useShowBalance();
  // 总余额，是否云钱包
  const { totalBalance, isCloudWallet } = useCurrentWallet();
  // 链接钱包弹窗
  const modalState = useConnectWalletModal();
  // 三方钱包
  const walletHub = useThirdWallet();
  // 复制地址
  const [showCopy, setShowCopy] = useState(false);
  // 入金弹窗
  const [depositVisible, setDepositVisible] = useState(false);

  // 账户信息
  const assetInfo = {
    showBalance,
    totalBalance,
  };

  const iconMap = {
    send: 'https://s1.bycsi.com/bybit/deadpool/image-fc464c8dfb4d4c97af6b2615bb0a609e.svg',
    receive:
      'https://s1.bycsi.com/bybit/deadpool/image-e3120b96fa7d4bc99e9091a22140dc4a.svg',
    swap: 'https://s1.bycsi.com/bybit/deadpool/image-d9c10f8f863048578386de4e4ee9f759.svg',
    buy: 'https://s1.bycsi.com/bybit/deadpool/image-c0e1074a8b0e4c92bb9373328d8ab993.svg',
  };

  const handleConnect = () => {
    modalState.show();
  };

  const handleCopy = () => {
    if (isCloudWallet) {
      setShowCopy(true);
    } else {
      // copy
      try {
        const address = walletHub?.wallets?.EVM?.address ?? '';
        if (address) {
          copy(address);
          toast({
            iconType: EToastType.SUCCESS,
            title: fm('copySuccess'),
          });
        }
      } catch (e) {
        console.error('copy failed', e);
      }
    }
  };

  const walletDisplayDom = !modalState.visible ? (
    <ArrowdownIcon onClick={handleConnect} className={styles.caret} />
  ) : (
    <ArrowupIcon onClick={handleConnect} className={styles.caret} />
  );

  const navTo = (type = 'swap') => {
    scTrack(Event.Web3UserClick, {
      page_name: Page.Home,
      area: 'Banner',
      button_name: type,
    });
    if (isMobile) {
      const map = {
        swap: goSwap,
        buy: goBuy,
      };
      map[type]?.();
      return;
    }
    const map = {
      swap: normalizeLink('/web3/swap-bridge'),
      buy: normalizeLink('/web3/buy-crypto'),
    };
    window.open(map[type], '_blank');
  };

  const walletName = isCloudWallet ? fm('cloudWallet') : walletHub?.name;

  const handleToggleAssets = () => {
    // walletInfo.handleToggleAssets?.();
    showBalance ? hideBalance(false) : setShowBalance();
  };

  const bybitLogo = `${window.location.origin}/web3/static/bybit-wallet-round.8411c94e.svg`;
  const logo = (!isCloudWallet && walletHub?.icon) || bybitLogo;

  return (
    <>
      <ToastContainer />
      <div className={styles.login}>
        <div className={styles.wallet}>
          <img className={styles.icon} alt="img" src={logo} />
          <span className={styles.text} onClick={handleConnect}>
            {walletName}
          </span>
          {walletDisplayDom}
          <Divider type="vertical" className={styles.div} />
          <CopyIcon className={styles.copyIcon} onClick={handleCopy} />
          <Web3CopyCloudWalletModal
            visible={showCopy}
            onClose={() => setShowCopy(false)}
          />
        </div>
        <div className={styles.balance}>
          <span>
            {assetInfo?.showBalance
              ? assetInfo?.totalBalance
                ? `$ ${formatNumber(assetInfo?.totalBalance, {
                    decimal: 2,
                    smallerThanX: 2,
                    noTrailZero: true,
                  })}`
                : '--'
              : '****'}
          </span>{' '}
          {!assetInfo?.showBalance ? (
            <EyeoffIcon className={styles.icon} onClick={handleToggleAssets} />
          ) : (
            <EyeonIcon className={styles.icon} onClick={handleToggleAssets} />
          )}
        </div>
        {isCloudWallet ? (
          <>
            <Web3DepositModal
              visible={depositVisible}
              onClose={() => setDepositVisible(false)}
            />
            <div className={styles.receive}>
              <Button
                variant="secondary"
                onClick={() => {
                  setDepositVisible(true);
                }}
              >
                <img alt="img" src={iconMap.receive} />
                {fm('web3_receive')}
              </Button>
              <Button
                variant="secondary"
                onClick={() => {
                  // TODO 暂时跳转到资产页，待迁移完成
                  // walletInfo.handleWithdrawAll?.();
                  web3Navigate(replacePath('/web3/balance'));
                }}
              >
                <img alt="img" src={iconMap.send} />
                {fm('web3_send')}
              </Button>
            </div>
            <div className={styles.actions}>
              <div className={styles.action} onClick={() => navTo('swap')}>
                <img className={styles.icon} alt="img" src={iconMap.swap} />
                <span className={styles.title}>{fm('web3_swap')}</span>
              </div>
              <div className={styles.action} onClick={() => navTo('buy')}>
                <img className={styles.icon} alt="img" src={iconMap.buy} />
                <span className={styles.title}>{fm('web3_buy')}</span>
              </div>
            </div>
          </>
        ) : null}
      </div>
    </>
  );
};
